/**
 * Captures the host WordPress theme's paragraph font and applies it to the app.
 *
 * The CSS tokens `--font-family-body` and `--font-weight-default` default to
 * `inherit`, which resolves against the mount node's parent. That is not always
 * the same as the theme's `<p>` styling, and modal portals mount on
 * `document.body` where it is not the same at all. Measuring a throwaway `<p>`
 * and writing the result to the document root fixes both cases at once.
 *
 * Only family and weight are captured — font sizing stays on Spaces tokens.
 */
export function inheritHostFont (container: HTMLElement): void {
	const parent = container.parentElement
	if (!parent) return

	const probe = document.createElement('p')
	probe.style.cssText = 'position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;pointer-events:none'
	parent.appendChild(probe)

	const computed = window.getComputedStyle(probe)
	const fontFamily = computed.fontFamily
	const fontWeight = computed.fontWeight

	probe.remove()

	// Set on the root so body-level modal portals inherit the same values.
	const root = document.documentElement
	if (fontFamily) root.style.setProperty('--spaces-font-family-body', fontFamily)
	if (fontWeight) root.style.setProperty('--spaces-font-weight-default', fontWeight)
}
